import { useContext } from 'react';
import { ConsentBannerUI } from '@/components/ui';
import {
  ConfigContext,
  PrivacySettingsContext,
  WidgetStateContext,
} from '@/context';
import { handleError } from '@/utils/error';

type Props = {
  zIndex: number;
};

export function ConsentBanner({ zIndex }: Props) {
  const {
    toggleOpen,
    bannerClosed,
    setBannerClosed,
    open: privacyCenterOpen,
    consentManagementEnabled,
  } = useContext(WidgetStateContext);
  const {
    consentMode,
    doNotSellConsentEnabled,
    gpcSignal,
    privacySettingsSet,
    updatePrivacySettings,
  } = useContext(PrivacySettingsContext);

  const {
    bannerTheme,
    bannerEnabled,
    bannerLayout,
    bannerPosition,
    bannerTitleEnabled,
    bannerTitleText,
    bannerText,
    policyUrl,
    bannerLinkText,
    gcmEnabled,
    gcmPolicyUrl,
    gcmLinkText,
    closeButtonEnabled,
    acceptButtonText,
    denyButtonEnabled,
    denyButtonText,
    customizeButtonEnabled,
    customizeButtonText,
    doNotSellText,
    gpcText,
    showGooglePrivacyPolicy,
  } = useContext(ConfigContext);

  const addConsentEvents = async ({
    acceptAll,
    doNotSell,
  }: {
    acceptAll: boolean;
    doNotSell: boolean;
  }) => {
    try {
      updatePrivacySettings({ acceptAll, doNotSell, gpcSignal });
      setBannerClosed(true);
    } catch (err) {
      handleError(err);
    }
  };

  function showBanner() {
    if (!consentManagementEnabled) {
      return false;
    }
    if (!bannerEnabled) {
      return false;
    }
    if (consentMode === 'express') {
      return !privacySettingsSet && !bannerClosed;
    }
    if (consentMode === 'implied') {
      return !bannerClosed;
    }
    return false;
  }

  return showBanner() ? (
    <ConsentBannerUI
      bannerTheme={bannerTheme as 'light' | 'dark' | 'brand'}
      shiftFocusOnLoad={true}
      {...{
        zIndex,
        privacyCenterOpen,
        bannerLayout,
        bannerPosition,
        bannerTitleEnabled,
        bannerTitleText,
        bannerText,
        policyUrl,
        bannerLinkText,
        gcmEnabled,
        gcmPolicyUrl,
        gcmLinkText,
        customizeButtonEnabled,
        denyButtonEnabled,
        closeButtonEnabled,
        acceptButtonText,
        denyButtonText,
        customizeButtonText,
        onCustomizeClick: () => toggleOpen(),
        onFinishClick: addConsentEvents,
        doNotSellEnabled: doNotSellConsentEnabled,
        gpcSignal,
        doNotSellText,
        gpcText,
        showGooglePrivacyPolicy,
      }}
    />
  ) : (
    <></>
  );
}
